@if (hasIcon()) {
  <ng-container [ngTemplateOutlet]="iconContent"></ng-container>
} @else if (iconSpacerEnabled() && iconSpacerSize) {
  <div class="icon-spacer" [style.height.px]="iconSpacerSize.height" [style.width.px]="iconSpacerSize.width"></div>
}
<ng-container *ngTemplateOutlet="label" />

<span class="align-end glxy-list-item-accessory">
  <ng-content select="[glxy-list-item-accessory], [glxyListItemAccessory]" />
</span>

<ng-template #iconContent>
  <span class="glxy-list-item-icon" aria-hidden="true">
    <ng-content select="[glxy-list-item-icon], [glxyListItemIcon]" />
  </span>
</ng-template>

<ng-template #label>
  <div class="glxy-list-label-container">
    <ng-content />
  </div>
</ng-template>
